import { TacticLogo } from "@cmp-src/icons/TacticLogo/TacticLogo";
import { Button } from "@cmp-src/primitives/button";
import { cn } from "@gettactic/helpers";
import React from "react";
import { SetupNavBar } from "@/features/setup/components/SetupNavBar";
import { SETUP_THEME } from "@/theme";
import { applyTheme } from "@/theme/utils";

applyTheme(SETUP_THEME);

export interface SetupModernBoxProps {
  currentStep?: string;
  header?: React.ReactNode;
  onNext?: () => void;
  nextLabel?: string;
  isLoading?: boolean;
  isNextDisabled?: boolean;
  title?: string;
  description?: React.ReactNode;
}

export const SetupModernBox: React.FC<
  React.PropsWithChildren<SetupModernBoxProps>
> = ({
  children,
  currentStep,
  header,
  isLoading,
  onNext,
  nextLabel,
  isNextDisabled,
  title,
  description
}) => {
  const withSteps = !!currentStep;
  return (
    <>
      {/*<SetupAnimatedBackground />*/}

      <div
        className={"flex h-screen w-screen flex-col"}
        style={{
          background:
            "linear-gradient(295deg, rgba(209, 238, 237, 1) 0%, rgba(208, 227, 249, 1) 100%)"
        }}
      >
        {withSteps && (
          <div className={"h-[74px] w-full"}>
            <SetupNavBar currentStep={currentStep} />
          </div>
        )}
        <div
          className={cn(
            "tactic-setup-box",
            "flex w-full flex-col items-center overflow-y-auto overflow-x-hidden py-4 md:px-24 md:py-20",
            withSteps ? "" : "flex-1 justify-center bg-white md:bg-transparent"
          )}
        >
          {(!!title || !!description) && (
            <div className={"mb-8 flex w-full flex-col gap-2 px-4"}>
              {!!title && (
                <h2 className={"setup-title w-full text-[25px] md:text-[56px]"}>
                  {title}
                </h2>
              )}
              {!!description && (
                <div
                  className={
                    "w-full max-w-[1500px] text-[#4D5978] md:text-[20px]"
                  }
                >
                  {description}
                </div>
              )}
            </div>
          )}
          <div
            className={cn(
              "flex w-full flex-col items-center bg-white pt-[60px] pb-[100px] md:rounded-[34px] md:px-12 md:pb-[60px] md:shadow-2xl",
              withSteps
                ? "max-w-[1800px] flex-1"
                : "max-w-[600px] md:bg-white/65"
            )}
          >
            {header && <div className={"w-full px-12"}>{header}</div>}
            {!withSteps && (
              <TacticLogo titleColor={"#112140"} logoColor={"#00A7B3"} />
            )}
            {withSteps ? (
              <div className={"relative h-full w-full flex-1"}>
                <div className={"px-12"}>{children}</div>
              </div>
            ) : (
              <div className={"px-12"}>{children}</div>
            )}
            {onNext && (
              <div className="fixed right-0 bottom-0 left-0 flex w-full justify-between px-6 py-2 md:static md:mt-6 md:px-0 md:py-0">
                <div />
                <Button
                  disabled={isNextDisabled}
                  size="lg"
                  type="submit"
                  onClick={onNext}
                  isLoading={isLoading}
                  className="font-bold"
                >
                  {nextLabel || "Next"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
